import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  status = false;

  pendingRequests = 0;


  constructor() { }

  startRequest() {
    // Incrementamos el contador de peticiones pendientes
    this.pendingRequests++;

    // Si es la primera petición, mostramos la pantalla de espera
    if (this.pendingRequests === 1) {
      this.status = true;
    }
  }

  endRequest() {
    // Decrementamos el contador de peticiones pendientes
    this.pendingRequests--;

    // Si ya no hay peticiones pendientes, ocultamos la pantalla de espera
    if (this.pendingRequests === 0) {
      this.status = false;
    }
  }

}
